<template>
  <div class="fields__field fields__field--radio" :class="{ '-error': error }">
    <div class="field__label">
      <span class="control-label bold">{{ label }}</span>
    </div>
    <div class="field__radio">
      <div class="group-list">
        <div class="radio" v-for="(item, key) in items" :key="key" :class="{'-checked': value === item.value }">
          <label :for="item.identifier" class="radio__label">
            <input type="radio" class="form-check-input" :name="identifier" :id="item.identifier" :value="item.value" @click="$emit('input', $event.target.value)">
            <span>{{ item.text }}</span>
          </label>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['label', 'identifier', 'items', 'value', 'error']
}
</script>
